import { getApiPDF } from 'apis';

const downloadDocument = async (data: any) => {
	return await getApiPDF(`/files/download`, data);
};

export const fileSystemService = { downloadDocument };
